import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

/**
 * Reports lightweight telemetry (device/browser + logins) to the backend for
 * support diagnosis. Staff-only enforcement lives server-side. Fire-and-forget;
 * never throws into the app.
 */
function webDevice() {
  const ua = navigator.userAgent || "";
  return {
    platform: "web",
    osVersion: navigator.platform || undefined,
    appVersion: process.env.REACT_APP_VERSION || "web",
    appBuild: process.env.REACT_APP_COMMIT || undefined,
    model: ua.slice(0, 200),
  };
}

export const recordWebTelemetry = async (
  kind: "login" | "action" | "error",
  event?: string,
  detail?: Record<string, unknown>
): Promise<void> => {
  try {
    await httpsCallable(functions, "recordTelemetry")({ kind, event, detail, device: webDevice() });
  } catch {
    /* best-effort; never affects the app */
  }
};
